module.exports = __webpack_public_path__ + "images/106_640.jpg";